<template>
  <md-tab id="tab-sales-class" md-label="Companies" md-icon="class">
    <PulseLoader :loading="loading" :class="{hide: !loading || searchLoadingCompany}"></PulseLoader>
    <div class="md-layout" :class="{h_auto: loading || searchLoadingCompany}">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <company-sidebar title="Favorite Companies" />
        <div>
          <!-- <pulse-loader
            :color="'blue'"
            :loading="loading || searchLoadingCompany"
          ></pulse-loader> -->
        </div>
        <!-- Favorite Company -->
        <ul class="favorite-list" v-if="company">
          <li class="favorite-list-item">
            <div class="list-item-head">
              <div>
                <input
                  aria-label="List item"
                  @change="nextTickInput(company, $event)"
                  type="checkbox"
                  :id="'checkbox'"
                  :value="company.company_name"
                  v-model="favoriteToggle"
                  disabled
                />
                <span class="icon mr-5">{{ company.company_name }}</span>
                <md-icon
                  @click.native="removeFavorite($event)"
                  v-if="companiesShow != null"
                  class="action-icon"
                  style="color: #0F66C5; cursor: pointer"
                  >replay
                </md-icon>
                <div class="list-item-body">
                  {{ `${company.state}, ${company.zip}` }}
                </div>
              </div>
              <span class="actions ml-5">
                <md-button
                  @click="
                    createAndRedirect(
                      company.data.infogroup_id,
                      company.data.zip,
                      $event
                    )
                  "
                  class="md-dense md-info md-block access-button"
                >
                  Profile
                </md-button>
              </span>
            </div>
          </li>
        </ul>
        <!-- Search Company -->
        <ul v-if="searchCompanies != null" class="favorite-list">
          <li
            v-for="(company, index) in searchCompanies"
            :key="refreshKey + index"
            class="favorite-list-item"
          >
            <div class="list-item-head">
              <div>
                <input
                  aria-label="List item"
                  @change="nextTickInput(company, $event)"
                  type="checkbox"
                  :id="'checkbox' + index"
                  :value="company.company_name"
                  v-model="company.checked"
                />
                <span class="icon mr-5">{{ company.data.company_name }}</span>
                <md-icon
                  @click.native="favoriteCompany(company, $event)"
                  v-if="companiesShow != null"
                  class="action-icon"
                  style="color: #0F66C5; cursor: pointer"
                  >star_border
                </md-icon>
                <div class="list-item-body">
                  {{ `${company.data.state}, ${company.data.zip}` }}
                </div>
              </div>
              <span class="actions ml-5">
                <md-button
                  @click="
                    createAndRedirect(
                      company.data.infogroup_id,
                      company.data.zip,
                      $event
                    )
                  "
                  class="md-dense md-info md-block access-button"
                >
                  Profile
                </md-button>
              </span>
            </div>
          </li>
        </ul>
        <div
          class="available"
          @click="setIndustryDialog"
          v-if="
            !loading &&
              !loaded &&
              !company &&
              !searchCompanies &&
              !searchLoadingCompany
          "
        >
          Start by choosing an industry
        </div>
        <div
          style="display: flex;"
          class="btn_wpr"
          v-if="loaded && !company && !searchCompanies && !searchLoadingCompany"
        >
          <div
            v-if="loaded"
            @click="sortCompanies($event)"
            class="company-sort-font"
          >
            <md-icon
              v-if="toggleSort != null"
              class="action-icon"
              style="color: #0F66C5; cursor: pointer"
              >{{ toggleSort ? 'arrow_drop_up' : 'arrow_drop_down' }}
            </md-icon>
            Companies
          </div>
          <div
            v-if="loaded"
            @click="uncheckAll($event)"
            class="available-modal custom_btn"
          >
            Customize Company List
          </div>
          <div
            v-if="loaded"
            @click="checkAll($event)"
            class="available-modal reset_btn"
          >
            Reset Custom Company List
          </div>
        </div>
        <ul
          v-if="loaded && !company && !searchCompanies && !searchLoadingCompany"
          class="favorite-list company_list"
        >
          <li
            v-for="(company, index) in companiesShow"
            :key="refreshKey + index"
            class="favorite-list-item"
          >
            <div class="list-item-head">
              <div>
                <input
                  aria-label="List item"
                  @change="nextTickInput(company, $event)"
                  type="checkbox"
                  :id="'checkbox' + index"
                  :value="company.company_name"
                  v-model="company.checked"
                  :disabled="!customizable"
                />
                <span class="icon mr-5">{{ company.data.company_name }}</span>
                <md-icon
                  @click.native="favoriteCompany(company, $event)"
                  v-if="companiesShow != null"
                  class="action-icon"
                  style="color: #0F66C5; cursor: pointer"
                  >star_border
                </md-icon>
                <div class="list-item-body">
                  {{ `${company.data.state}, ${company.data.zip}` }}
                </div>
              </div>
              <span class="actions ml-5">
                <md-button
                  @click="
                    createAndRedirect(
                      company.data.infogroup_id,
                      company.data.zip,
                      $event
                    )
                  "
                  class="md-dense md-info md-block access-button"
                >
                  Profile
                </md-button>
              </span>
            </div>
          </li>
        </ul>
        <div class="pagination_wpr">
          <div v-show="!loading" class="pagin-page-info pagination-font">
            Showing page:
            {{ pagination.currentPage }}
            of {{ Math.floor(pagination.total / pagination.perPage) }}
          </div>
          <div v-show="!loading" class="md-toolbar-section-end">
            <pagination
              class="pagination-no-border pagination-info"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @click.native="getPage()"
            >
            </pagination>
          </div>
        </div>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30"
      >
        <!-- <company-sidebar title="Favorite Companies" /> -->
      </div>
    </div>
  </md-tab>
</template>

<script>
import { Pagination } from '@/components';
import CompanySidebar from './CompanySidebar';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components';
import axios from 'axios';

export default {
  name: 'company-tab',
  props: {},
  components: {
    Pagination,
    CompanySidebar,
    PulseLoader,
  },
  data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: undefined,
      },
      loading: false,
      loaded: false,
      companies: [],
      pageStart: 0,
      pageEnd: 25,
      checkCount: 0,
      sorted: false,
      refreshKey: 0,
      toggleSort: null,
      customizable: false,
      favoriteToggle: true,
      initialLocnums: null,
    };
  },
  methods: {
    createAndRedirect: async function(id, zip, event) {
      event.stopPropagation();
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/create/companyProfile',
          {},
          {
            params: {
              session_id: currentSession,
              locnum: id,
              zip: zip,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/create/companyProfile" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id: reportId } = res.data;
          this.$router.push({
            name: 'CompanyProfile',
            params: { id: reportId },
          });
        });
    },
    removeFavorite: function(event) {
      event.stopPropagation();
      this.$store.commit('SET_COMPANY', null);
      this.getCompanies();
    },
    setIndustryDialog: function() {
      this.$store.commit('SET_INDUSTRY_DIALOG', true);
    },
    uncheckAll: function(event) {
      event.stopPropagation();
      this.companies.forEach((item) => (item.checked = false));
      this.checkCount = 0;
      this.$store.commit('SET_PRICE', '');
      this.$store.commit('SET_COMPANIES_COUNT', '');
      this.$store.commit('SET_LOCNUMS', []);
      this.customizable = true;
    },
    checkAll: async function(event) {
      event.stopPropagation();
      this.checkCount = 0;
      this.customizable = false;
      this.companies.forEach((item) => (item.checked = true));
      await this.getCompanies();
    },
    favoriteCompany: async function(item, event) {
      event.stopPropagation();

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      const companyData = item.data.infogroup_id;

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/favorites/add',
          {},
          {
            params: {
              session_id: currentSession,
              category1: 'universal',
              category2: 'company',
              data: companyData,
              search1: item.data,
              search2: companyData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/CompanyListPrice" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          this.$store.commit('PUSH_TO_FAVORITE_COMPANIES', {
            data: companyData,
            search1: item.data,
            id: res.data.favorite_id,
          });
        });
    },
    nextTickInput: async function(item, event) {
      event.stopPropagation();
      this.$nextTick(async () => {
        if (item.checked) {
          this.checkCount += 1;
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + '/info/CompanyListPrice', {
              params: {
                count: this.checkCount,
              },
            })
            .then((res) => {
              if (res.hasOwnProperty('data') && res.data.error) {
                this.$store.commit('SET_ERROR_BIT', true);
                this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/CompanyListPrice" <br>`
                );
                throw new Error(
                  '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode
                );
              }
              this.$store.commit('SET_PRICE', res.data.price);
              this.$store.commit('SET_COMPANIES_COUNT', res.data.count);
              this.$store.commit('PUSH_TO_LOCNUMS', item.data.infogroup_id);
            });
        } else {
          this.checkCount -= 1;
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + '/info/CompanyListPrice', {
              params: {
                count: this.checkCount,
              },
            })
            .then((res) => {
              if (res.hasOwnProperty('data') && res.data.error) {
                this.$store.commit('SET_ERROR_BIT', true);
                this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/CompanyListPrice" <br>`
                );
                throw new Error(
                  '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode
                );
              }
              this.$store.commit('SET_PRICE', res.data.price);
              this.$store.commit('SET_COMPANIES_COUNT', res.data.count);
              this.$store.commit('REMOVE_FROM_LOCNUMS', item.data.infogroup_id);
            });
        }
      });
    },
    sortCompanies: function(event) {
      event.stopPropagation();
      if (this.sorted) {
        this.companiesShow.sort((a, b) =>
          a.company_name < b.company_name ? 1 : -1
        );
        this.toggleSort = this.sorted;
        this.sorted = !this.sorted;
        this.refreshKey++;
      } else {
        this.companiesShow.sort((a, b) =>
          a.company_name > b.company_name ? 1 : -1
        );
        this.toggleSort = this.sorted;
        this.sorted = !this.sorted;
        this.refreshKey++;
      }
    },
    getPage() {
      if (this.pagination.currentPage == 1) {
        this.pageStart = 0;
        this.pageEnd = 25;
      } else {
        this.pageEnd = 25 * this.pagination.currentPage;
        this.pageStart = this.pageEnd - 25;
      }
    },
    getName: function(name) {
      return name.split('[')[0];
    },
    getData: function(name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    isRightSalesRange() {
      if (this.salesRangeFrom && this.salesRangeTo) {
        return parseInt(this.salesRangeFrom) < parseInt(this.salesRangeTo);
      }

      return false;
    },
    getCompanies: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      if (this.industry !== null) {
        this.loading = true;
        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
            {},
            {
              params: {
                session_id: currentSession,
                profile_id: this.profileId ? this.profileId : '0',
                type: 'company',
                industry: this.getData(this.industry),
                area: this.getData(this.marketArea),
                sales_from: this.isRightSalesRange() ? this.salesRangeFrom : '',
                sales_to: this.isRightSalesRange() ? this.salesRangeTo : '',
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_lists/company" <br>`
              );
              throw new Error(
                '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode
              );
            }
            const { count, price, data, id } = res.data;
            this.loaded = true;
            this.loading = false;
            this.$store.commit('F_SET_PROFILE_ID', id);
            this.$store.commit('SET_PRICE', price);
            this.$store.commit('SET_COMPANIES_COUNT', count);
            this.companies = data.map(function(item) {
              return { data: item, checked: true };
            });
            this.initialLocnums = data.map((item) => item.infogroup_id);
            this.$store.commit('SET_LOCNUMS', this.initialLocnums);
          });
      }
    },
  },
  created() {
    this.getCompanies();
  },
  computed: {
    profileId() {
      return this.$store.getters.fProfileId;
    },
    industry() {
      return this.$store.getters.fIndustry;
    },
    marketArea() {
      return this.$store.getters.fMarketArea;
    },
    salesRangeFrom() {
      return this.$store.getters.salesRangeFrom;
    },
    salesRangeTo() {
      return this.$store.getters.salesRangeTo;
    },
    companiesShow() {
      return this.companies
        ? this.companies.slice(this.pageStart, this.pageEnd)
        : [];
    },
    companiesCount() {
      return this.$store.getters.companiesCount || 0;
    },
    company() {
      return this.$store.getters.company;
    },
    searchInputCompany() {
      return this.$store.getters.searchInputCompany;
    },
    searchCompanies() {
      return this.$store.getters.searchCompanies;
    },
    searchLoadingCompany() {
      return this.$store.getters.searchLoadingCompany;
    },
    locnums() {
      return this.$store.getters.locnums;
    },
  },
  watch: {
    industry() {
      this.getCompanies();
    },
    marketArea() {
      this.getCompanies();
    },
    salesRangeFrom() {
      this.getCompanies();
    },
    salesRangeTo() {
      this.getCompanies();
    },
    companiesCount(newValue, oldValue) {
      this.pagination.total = parseInt(newValue);
    },
    searchInputCompany(newValue, oldValue) {
      if (!newValue) {
        this.getCompanies();
      }
    },
    customizable(newValue) {
      this.$store.commit('SET_CUSTOMIZABLE', newValue);
    },
  },
};
</script>
<style lang="scss">
.md-collapse-label:after {
  height: 0 !important;
}

.company-sort-font {
  font-family: Quicksand;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  align-items: center;
  letter-spacing: 0.44px;
  /* Gray · 60% */
  color: #919699;
  margin-right: 24px;
}

.company-sort-font:hover {
  color: #0f66c5;
  cursor: pointer;
}

.pagination-font {
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.5em;
}
</style>
